module.exports = "https://static.wmbcdn.com/uniweb/images/3fcc0f609310a0edb187baa9ec6307cd.svg";